<div class="my-5">
  <!-- page-header -->
  <sm-page-header
    *ngIf="!companyId"
    [breadcrumb]="breadcrumb"
    title="settings.bankDetails.title"
    description="settings.bankDetails.description">
  </sm-page-header>
  <!-- content -->
  <div [ngClass]="{ content: !companyId }">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="bankDetailsDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="bankDetailsDialog"></sm-dialog>
</div>
